import { IllumioEventEmitter  } from "../common/event_emitter.js";
import IllumioDomUtils from "../common/dom_utils.js";
import IllumioSupportUtils from "../common/support_utils.js";

/**********************************************************************
 * Eula Acceptence MVC
 *********************************************************************/

export class EulaModel extends IllumioEventEmitter {
    constructor() {
        super();

        this.product = null;
        this.type = null; // Example: Download, Upgrade, Custom, etc.
        
        this.acceptanceId = null;
        this.checked = false;
        this.disabled = false;
        
        // this.modelChangeEvent = new IllumioEvent(this);
        // this.errorMessageEvent = new IllumioEvent(this);

        this.csrfToken = this.retrieveCsrfToken();
    }
    
    retrieveCsrfToken() {
        const csrfTokenElements = document.getElementsByName('csrf-token');
        if (csrfTokenElements.length>0 && csrfTokenElements[0].tagName==='META' && csrfTokenElements[0].content) {
            return csrfTokenElements[0].content;
        } else {
            console.warn('EulaModel: retrieveCsrfToken(): Unable to retreive csrf token from the meta tags!');
        }
        
        return null;
    }

    acceptEula() {
        console.debug('EulaModel: acceptEula(): ');
        console.debug(this);
        
        if (!this.isEulaAccepted()) {
            const payload = {
                'url': location.href,
                'summary': this.type,
                'authenticity_token': this.csrfToken,
            }
            console.debug(payload);
            $.ajax({
                dataType: 'json',
                method: 'post',
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify(payload),
                url: '/api/v1/software/eula_acceptance.json',
                error: this.ajaxErrorHandler.bind(this),
                success: this.ajaxSuccessHandler.bind(this),
            });
        }
    }
    
    // --- Handler ----------------------------------------------------
    ajaxSuccessHandler(data, textStatus, jqXHR) {
        // this.errorMessageEvent.notify(null);
        // this.emit('errorMessage', { message: `Hello World! `});
        
        if (data && data.software_eula_acceptance && data.software_eula_acceptance.id) {
            this.acceptanceId = data.software_eula_acceptance.id;
            this.checked = true;
            this.disabled = true;
            // this.modelChangeEvent.notify();
            this.emit('modelChange', {});
            
            if (this.product && this.type) {
                IllumioSupportUtils.trackGaEvent('EULA Acceptance', this.product, this.type); 
                console.debug('EulaModel: ajaxSuccessHandler(): Tracking EULA Acceptance: ' + this.product + '|' + this.type)
            } else {
                console.debug('EulaModel: ajaxSuccessHandler(): Unable to track EULA Acceptance due to missing product and/or type.');
            }
        } else {
            console.error('EulaModel: ajaxSuccessHandler(): Unable to determine acceptance ID.');
        }
        
        console.debug(data);
        // console.debug(textStatus);
        // console.debug(jqXHR);
    }
    
    ajaxErrorHandler(jqXHR, textStatus, errorThrown) {
        this.success = false;
        
        // this.errorMessageEvent.notify('We are experiencing technical difficulty in tracking your EULA acceptance. Please try again later.');
        this.emit('errorMessage', { message: 'We are experiencing technical difficulty in tracking your EULA acceptance. Please try again later.' });
        
        console.error('Error in loading eula_acceptance.json');
        console.debug(textStatus);
        console.debug(errorThrown);
        console.debug(jqXHR);
    }
    
        /**
         * Public method
         */
        isEulaAccepted() {
console.debug(`EulaModel.isEulaAccepted(): this.acceptanceId: [${this.acceptanceId}]`)
            return (this.acceptanceId && this.acceptanceId.length>0) ? true : false;
        }

        /**
         * Public method
         */
        update() {
            if (this.isEulaAccepted()) {
                console.debug('EulaModel: update(): EULA was previously accepted!');
            } else {
                this.acceptEula();
            }
        }
}

export class EulaView extends IllumioEventEmitter {
    constructor(model) {
        super();

        this.model = model;
        
        this.checkboxElement = null; // To be initialized in createEulaDom().
        
        // The owner object will set the following Element objects. 
        this.errorElement = null;
        this.eulaElement = null;
        this.eulaLink = null;
        
        // this.checkboxChangeEvent = new IllumioEvent(this);
        
        // this.model.modelChangeEvent.attach(disableCheckboxHandler.bind(this));
        // this.model.errorMessageEvent.attach(errorMessageEventHandler.bind(this));
        this.model.on('modelChange', this.disableCheckboxHandler.bind(this));
        this.model.on('errorMessage', this.errorMessageEventHandler.bind(this));

        this.eulaAcceptanceModal = document.getElementById('eulaAcceptanceModal');
        this.eulaAcceptanceModal.addEventListener('close', this.eulaAcceptanceCloseHandler.bind(this));
        
        // const closeButton = document.getElementById('eulaCloseButton');
        // if (closeButton) {
        //     closeButton.onclick = this.closeButtonOnClickHandler.bind(this);
        // }
        // const continueButton = document.getElementById('eulaAcceptanceContinueButtonLink');
        // if (continueButton){
        //     continueButton.onclick = this.continueButtonClickHandler.bind(this);
        // }
    }
    
    /**
        <div class="row download-content eula">
            <div class="small-16 columns">
                <h3>EULA Acceptance</h3>
            </div>
            <div class="small-16 columns checkbox-wrapper">
                <label>
                    <input type="checkbox" name="download_eula" id="downloadEula" value="true" required="" data-tab-id="download" disabled="" data-eula-acceptance-id="c1eb6c66-25ed-415f-aeda-94ff4337e34f">
                    <div class="description"><span class="required">*</span> By checking the box you acknowledge that you have read, understand and agree to be bound by the 
                    <a target="illumio" href="https://www.illumio.com/eula">Illumio, Inc. End User License Agreement</a>.</div>
                </label>
            </div>
        </div>
     */
    createEulaDom() {
        this.checkboxElement = document.createElement('input');
        this.checkboxElement.type = 'checkbox';
        this.checkboxElement.value = true;
        this.checkboxElement.classList.add('checkbox');
        this.checkboxElement.required = true;
        this.checkboxElement.onchange = this.checkboxOnChangeHandler.bind(this);
        this.popupCheckboxElement = document.getElementById('popup-eulaInput');
        this.popupCheckboxElement.onchange = this.checkboxOnChangeHandler.bind(this);
        if (this.model.isEulaAccepted()) {
            this.checkboxElement.disabled = true;
            this.checkboxElement.checked = true;
            this.popupCheckboxElement.disabled = true;
            this.popupCheckboxElement.checked = true;
        }
        
        const descriptionElement = IllumioDomUtils.createNode('span', IllumioDomUtils.createNode('span', '*', 'required'), 'description');
        descriptionElement.appendChild(document.createTextNode(' By checking the box you acknowledge that you have read, understand and agree to be bound by the '));
        this.eulaLink = IllumioDomUtils.createAnchorTag('https://www.illumio.com/eula', 'Illumio, Inc. End User License Agreement');
        descriptionElement.appendChild(this.eulaLink);
        descriptionElement.children[descriptionElement.childElementCount-1].target = 'illumio';
        descriptionElement.appendChild(document.createTextNode('.'));

        const labelElement = document.createElement('label');
        labelElement.appendChild(this.checkboxElement);
        labelElement.appendChild(descriptionElement);
        
        const rootElement = document.createElement('div');
        rootElement.classList.add('checkbox-wrapper');
        rootElement.appendChild(IllumioDomUtils.createNode('h3', 'EULA Acceptance'));
        rootElement.appendChild(labelElement);
        
        return rootElement;
    }
    
    checkboxOnChangeHandler(event) {
        console.debug('EulaView: checkboxOnChangeHandler(): ');
        console.debug(event);
        console.debug(event.target);
        console.debug(event.target.checked);
        
        this.toggleErrorDescription(false);
        if (this.errorElement) {
            this.errorElement.classList.add('hidden');
        }
        // this.checkboxChangeEvent.notify();
        this.emit('checkboxChange', {});
    }
    
    disableCheckboxHandler() {
        console.debug('EulaView: disableCheckboxHandler()');
        // Note: The checked state at this point becomes false. Bug?
console.debug(`» this.checkboxElement.checked: ${this.checkboxElement.checked}`);
console.debug(`» this.checkboxElement.disabled: ${this.checkboxElement.disabled}`);
console.debug(`» this.popupCheckboxElement.checked: ${this.popupCheckboxElement.checked}`);
console.debug(`» this.popupCheckboxElement.disabled: ${this.popupCheckboxElement.disabled}`);
        this.checkboxElement.checked = true;
        this.checkboxElement.disabled = true;
        this.popupCheckboxElement.checked = true;
        this.popupCheckboxElement.disabled = true;
    }

    // TODO: Cleanup this method if we do not need this because of the DaisyUI. 
    // closeButtonOnClickHandler(event) {
    //     event.stopPropagation();
    //     $('#eulaAcceptanceModal').foundation('reveal', 'close');
    //    return false;
    // }
    
    // TODO: Cleanup this method if we do not need this because of the DaisyUI.
    // continueButtonClickHandler(event) {
    //     event.stopPropagation();
    //     this.model.anchorElement.click();
    //     $('#eulaAcceptanceModal').foundation('reveal', 'close');
    //     this.model.anchorElement = null;
    //     return false;
    // }

    eulaAcceptanceCloseHandler(event) {
        console.debug(`eulaAcceptanceCloseHandler()`);
        console.debug(event);

        if (this.model.anchorElement) {
            this.model.anchorElement.click();
            this.model.anchorElement = null;
        } else {
            console.debug(`this.model.anchorElement is null. No further action from here!`);
        }
        
        return false;
    }
    
    errorMessageEventHandler(payload) {
        console.debug('EulaView: errorMessageEventHandler()');
        if (payload) console.debug(`» payload: ${JSON.stringify(payload)}`);
        if (payload && payload['message']) {
            if (this.checkboxElement) {
                this.checkboxElement.checked = false;
            }
            if (this.popupCheckboxElement) {
                this.popupCheckboxElement.checked = false;
            }

            if (this.errorElement) {
                this.errorElement.textContent = message;
                this.errorElement.classList.remove('hidden');
            }
        } else {
            console.warn(`Payload not detected or missing required data in payload.`);
        }
    };
    
    toggleErrorDescription(status) {
        const descriptionElements = this.eulaElement.getElementsByClassName('description');
        if (descriptionElements.length>0) {
            if (status) {
                descriptionElements[0].classList.add('error');
            } else {
                descriptionElements[0].classList.remove('error');
            }
        }
        console.debug(this.eulaElement);
    }
    
        /**
         * Public method.
         */
        render() {
            if (this.eulaElement && this.eulaElement.childElementCount==0) {
                this.eulaElement.appendChild(this.createEulaDom());
                // this.eulaElement.classList.remove('hidden');
            }
        }

        /**
         * Public method.
         */
        updateEulaURL(url) {
            this.eulaLink.href = url;
        }

        /**
         * Public method.
         */
        renderAcceptanceRequirementAlert(anchorElement) {
console.debug(`renderAcceptanceRequirementAlert(): `);
console.debug(anchorElement);

            this.model.anchorElement = anchorElement;
            this.eulaAcceptanceModal.showModal();
            // this.$eulaAcceptanceModal.foundation('reveal', 'open');
            this.toggleErrorDescription(true);
        }
}

export class EulaController extends IllumioEventEmitter {
    constructor(model, view) {
        super();

        this.model = model;
        this.view = view;
        
        // this.view.checkboxChangeEvent.attach(checkboxChangeEventHandler.bind(this));
        this.view.on('checkboxChange', this.checkboxChangeEventHandler.bind(this));
        this.view.render();
    }

    checkboxChangeEventHandler() {
        console.debug('EulaController: checkboxChangeEventHandler(): ');
        this.model.update();
    }
}
